export const ALLOWED_UPLOAD_MIME_TYPES = Object.freeze([
  "application/pdf",
  "image/jpeg",
  "image/png",
]);

export const UPLOAD_ACCEPT = ALLOWED_UPLOAD_MIME_TYPES.join(",");
export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024;

export function validateSelectedFiles(fileList) {
  const acceptedFiles = [];
  let error = "";

  for (const file of Array.from(fileList || [])) {
    if (!ALLOWED_UPLOAD_MIME_TYPES.includes(file.type)) {
      error ||= "Yalnızca PDF, JPG/JPEG veya PNG dosyaları seçebilirsiniz.";
      continue;
    }
    if (file.size > MAX_UPLOAD_SIZE_BYTES) {
      error ||= "Her dosya en fazla 10 MB olabilir.";
      continue;
    }
    acceptedFiles.push(file);
  }

  return { acceptedFiles, error };
}
